<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="ORIM-Book-Title--Front-Matter-">Eros Descending</p>
<p class="ORIM-Book-Subtitle--Front-Matter-">Tales of the Velvet Comet Book 3</p>
<p class="ORIM-Author-Name--Front-Matter-2">Mike Resnick</p>
<p class="ORIM-logo2"><img alt="Logo" src="image/logo2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ErosDescending-1.vue?10077839